<template>
  <div>
    <!-- <div class="titleh1">
      <code />订单信息
    </div> -->
    <el-form ref="form" :model="form" label-width="100px">
      <div class="titleh1"><code />单号信息</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="货源单号">
            <el-input v-model="form.mainOrderNumber" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运单号">
            <el-input v-model="form.orderCode" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运单状态">
            <el-input v-model="form.status" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1"><code />地址信息</div>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="装货地址" style="margin-right: 15px">
              <el-input v-model="form.shipperAddress" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input v-model="form.shipperDetailAddress" :disabled="true" />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="卸货地址" style="margin-right: 15px">
              <el-input v-model="form.consigneeAddress" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input v-model="form.consigneeDetailAddress" :disabled="true" />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="发货联系人" style="margin-right: 15px">
              <el-input v-model="form.shipperName" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input v-model="form.shipperPhone" :disabled="true" />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple" style="margin-right: 15px">
            <el-form-item label="卸货联系人">
              <el-input v-model="form.consigneeName" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input v-model="form.consigneePhone" :disabled="true" />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="里程数" style="margin-right: 15px">
              <el-input v-model="form.distance" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />货物信息</div>
      <el-row>
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="货物名称" prop="name">
                <el-input v-model="form.coalTypeName" :disabled="true" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <el-form-item
                      label="货物数量"
                      prop="name"
                      style="margin-right: 15px"
                    >
                      <el-input v-model="form.weight" :disabled="true" />
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <el-input v-model="form.coalUnitName" :disabled="true" />
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item
                label="货物单价"
                prop="name"
                style="margin-right: 15px"
              >
                <el-input v-model="form.coalPrice" :disabled="true" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-select v-model="form.coalUnit" :disabled="true">
                <el-option label="元/吨" value="0" />
                <el-option label="元/方" value="1" />
                <el-option label="元/件" value="2" />
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item
                label="运费单价"
                prop="name"
                style="margin-right: 15px"
              >
                <el-input v-model="form.price" :disabled="true" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="form.isTrunkName" :disabled="true" />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <el-form-item label="合理耗损" style="margin-right: 15px">
                      <el-input
                        v-model="form.limitWastageAmount"
                        :disabled="true"
                      />
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <el-input
                      v-model="form.limitWastageTypeName"
                      :disabled="true"
                    />
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <!-- <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="车数要求">
              <el-input
                v-model="form.coalNumber"
                :disabled="true"
              />
            </el-form-item>
          </div>
        </el-col> -->
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="浮动费用" style="margin-right: 15px">
                    <el-input v-model.number="form.driftPrice" :disabled="true">
                      <template slot="append"
                        >元</template
                      >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="0">
                    <div class="radio_box">
                      <div
                        class="each_radio"
                        :class="{
                          sel_radio_ashes: form.isOrderReturn == '1',
                          radio_un: form.isOrderReturn != '1'
                        }"
                      />
                      <span :style="'cursor: no-drop;'">需要回单</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="运费抹零" style="margin-right: 15px">
              <!-- <el-input v-model="form.freightRoundingType" :disabled="true" /> -->
              <el-select
                v-model="form.freightRoundingType"
                placeholder="请选择"
                :disabled="true"
              >
                <el-option
                  v-for="item in optionsfreightRoundingType"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <!--  -->
      </el-row>
      <div class="titleh1"><code />装卸时间</div>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="装车时间" prop="date1">
              <div class="block">
                <el-input v-model="orderInfo.fillTime" :disabled="true" />
              </div>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="卸车时间" prop="date1">
              <div class="block">
                <el-input v-model="orderInfo.signTime" :disabled="true" />
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />其他信息</div>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="运输方式" prop="transportTypeName">
              <el-input v-model="form.transportTypeName" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="用车要求"
                    prop="name"
                    style="margin-right: 15px"
                  >
                    <el-input v-model="form.carModel" :disabled="true" />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-input v-model="form.carLength" :disabled="true" />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="运输要求">
              <el-input v-model="form.coalName" :disabled="true" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="购买保险">
              <el-select
                v-model="form.insuranceCode"
                :disabled="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in carneme"
                  :key="'carneme' + item.code"
                  :label="item.name"
                  :value="item.code"
                />
                <el-option label="不购买" value="8" />
              </el-select>
            </el-form-item>
          </div>
        </el-col>

        <!-- <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form-item label="应收(元)">
              <el-input v-model="form.inFee" placeholder clearable />
            </el-form-item>
          </div>
        </el-col>


        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="允许报价">
              <el-radio v-model="form.isQuote" label="1"> 是 </el-radio>
              <el-radio v-model="form.isQuote" label="0"> 否 </el-radio>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form-item label="最高价">
              <el-input v-model="form.maxPrice" placeholder clearable />
            </el-form-item>
          </div>
        </el-col>
        <el-col v-if="rainbowOnOff" :span="12">
          <el-form-item label="发布到云平台" label-width="136px">
            <el-radio v-model="form.isRainbowOn" :label="1"> 是 </el-radio>
            <el-radio v-model="form.isRainbowOn" :label="0"> 否 </el-radio>
          </el-form-item>
        </el-col> -->
      </el-row>
      <div class="titleh1">
        <code />司机信息
        <span style="color: #409EFF;cursor: pointer;" @click="viewCertificate"
          >查看证件</span
        >
      </div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="司机姓名">
            <el-input v-model="form.driverName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="司机电话">
            <el-input v-model="form.driverPhone" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input v-model="form.vehicleLicense" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1"><code />装货信息</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="装货重量">
            <el-input v-model="form.loadQuantity" :disabled="true">
              <template slot="append">
                {{ form.coalUnitName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="卸货重量">
            <el-input v-model="form.unloadQuantity" :disabled="true">
              <template slot="append">
                {{ form.coalUnitName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          v-if="
            (form.status == '已卸货' || form.status == '已核算') &&
              form.isTrunk == 0
          "
          :span="6"
        >
          <el-form-item label="结算重量">
            <el-input v-model="form.settlementWeight" :disabled="true">
              <template slot="append">
                {{ form.coalUnitName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="receiptNum-box">
          <el-form-item
            v-if="form.fillImageInfoList"
            label="装车图片"
            label-width="70px"
          >
            <div class="demo-image">
              <div
                v-for="url in form.fillImageInfoList"
                :key="url"
                style="display: inline-block; padding: 0 4px 4px 0;"
              >
                <el-image
                  v-if="url && url != ''"
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="form.fillImageInfoList"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="receiptNum-box">
          <el-form-item
            v-if="form.signImageInfoList"
            label="卸车图片"
            label-width="70px"
          >
            <div class="demo-image">
              <div
                v-for="url in form.signImageInfoList"
                :key="url"
                style="display: inline-block; padding: 0 4px 4px 0;"
              >
                <el-image
                  v-if="url && url != ''"
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="form.signImageInfoList"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="receiptNum-box">
          <el-form-item
            v-if="form.receiptImageUrls"
            label="回单照片"
            label-width="70px"
          >
            <div class="demo-image">
              <div
                v-for="url in form.receiptImageUrls"
                :key="url"
                style="display: inline-block; padding: 0 4px 4px 0;"
              >
                <el-image
                  v-if="url"
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="form.receiptImageUrls"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1"><code />异常信息</div>
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="其他费用">
              <el-input v-model="form.abnormalFee" :disabled="true">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="备注">
              <div>
                {{ form.abnormalRemark || "--" }}
              </div>
              <!-- <el-input
                v-model="form.abnormalRemark"
                :disabled="true"
              >
              </el-input> -->
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="异常图片">
              <template
                v-if="form.abnormalImgList && form.abnormalImgList.length"
              >
                <el-image
                  v-for="(value, index) in form.abnormalImgList"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px;"
                  :src="value"
                  :preview-src-list="form.abnormalImgList"
                />
              </template>
              <div v-else>--</div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />费用信息</div>
      <div class="border_dottle">
        <div class="driver_label">司机</div>
        <el-row>
          <el-col :span="10">
            <div class="dottle_flex_box">
              <div class="dottle_flex_box_item">
                <div>总司机费用</div>
                <div>(预估)</div>
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="form.deliveryFeeDeserved"
                  :disabled="true"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="14">
            <div class="dottle_flex_box">
              <div style="margin-top:9px;margin-right:12px;white-space:nowrap;">
                浮动费用
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="form.driftPrice"
                  style="width:480px;"
                  :disabled="true"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <div class="dottle_flex_box">
              <div class="dottle_flex_box_item">
                <div style="margin-top:9px;">损耗费用</div>
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input v-model.number="form.wastageFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="14">
            <div class="dottle_flex_box">
              <div
                style="margin-top:9px;margin-right:12px; white-space: nowrap;"
              >
                其他费用
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="form.abnormalFee"
                  style="width:480px;"
                  :disabled="true"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <div class="dottle_flex_box">
              <div class="dottle_flex_box_item">
                <div style="margin-top:9px;color:rgba(62, 155, 251, 1);">
                  司机净得
                </div>
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="form.deliveryFeePractical"
                  :disabled="true"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="14">
            <div
              style="display:flex;flex-wrap:nowrap;justify-content: flex-end;"
            >
              <div
                :class="[form.payType == '1' ? 'active_color_blue' : '']"
                style="white-space:nowrap;margin-right:12px;margin-top:7px;"
              >
                预付
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="form.prePay"
                  :class="[form.payType == '1' ? 'active_border_blue' : '']"
                  style="width:122px;"
                  :disabled="true"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
              <div
                :class="[form.arrivePayType == '1' ? 'active_color_blue' : '']"
                style="white-space:nowrap;margin-right:12px;margin-top:7px;margin-left:16px;"
              >
                到付
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="estimatedShipperFeeArrive"
                  :disabled="true"
                  style="width:122px;"
                  :class="[
                    form.arrivePayType == '1' ? 'active_border_blue' : ''
                  ]"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input></el-form-item
              >
              <div
                :class="[form.returnPayType == '1' ? 'active_color_blue' : '']"
                style="white-space:nowrap;margin-right:12px;margin-top:7px;margin-left:16px;"
              >
                回单付
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="form.returnAmount"
                  style="width:122px;"
                  :disabled="true"
                  :class="[
                    form.returnPayType == '1' ? 'active_border_blue' : ''
                  ]"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="border_dottle m_t_10">
        <div class="driver_label">托运人</div>
        <el-row>
          <el-col :span="12">
            <div class="dottle_flex_box">
              <div class="dottle_flex_box_item">
                <div>服务费</div>
                <div>(预付+到付)</div>
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input v-model.number="form.taxPayFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="dottle_flex_box">
              <div class="dottle_flex_box_item">
                <div>服务费</div>
                <div>(回单付)</div>
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="form.returnTaxFee"
                  style="width:400px;"
                  :disabled="true"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="dottle_flex_box">
              <div class="dottle_flex_box_item">
                <div style="margin-top:9px;">总服务费</div>
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input v-model.number="form.allTaxFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="dottle_flex_box">
              <div class="dottle_flex_box_item">
                <div style="margin-top:9px;" class="active_color_blue">
                  托运人应付
                </div>
              </div>
              <el-form-item style="margin-left:0px;" label-width="0px">
                <el-input
                  v-model.number="estimatedShipperFee"
                  style="width:400px;"
                  :disabled="true"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 油气配置 -->
      <div v-if="discountPoint > 0 || isAdmin" class="oil_svc_panel">
        <div class="oil_svc_header">
          <div class="oil_svc_header_left">
            <span class="oil_svc_pump_icon" aria-hidden="true">
              <img
                src="@/assets/icon/jiayou.png"
                alt=""
                width="16"
                height="16"
              />
            </span>
            <span class="oil_svc_title">油气服务</span>
            <span class="oil_svc_tag">部分使用</span>
          </div>
        </div>

        <div class="oil_svc_metrics">
          <div class="oil_svc_metric">
            <div class="oil_svc_metric_label">
              配额计划
              <span class="oil_svc_metric_code" />
            </div>
            <div class="oil_svc_metric_value">¥{{ form.oilFee || 0 }}</div>
          </div>
          <div class="oil_svc_metric">
            <div class="oil_svc_metric_label">实际加油金额</div>
            <div class="oil_svc_metric_value is-orange">
              ¥{{ form.payOil || 0 }}
            </div>
          </div>
          <div class="oil_svc_metric">
            <div class="oil_svc_metric_label">剩余额度</div>
            <div class="oil_svc_metric_value is-red">
              ¥{{ form.remainingOilFee }}
            </div>
          </div>
        </div>

        <div class="oil_svc_rate">
          <div class="oil_svc_progress">
            <div
              class="oil_svc_progress_bar"
              :style="{ width: oilQuotaUsageRate + '%' }"
            />
          </div>
          <div class="oil_svc_rate_row">
            <span>配额使用率</span>
            <span class="oil_svc_rate_pct">{{ oilQuotaUsageRate }}%</span>
          </div>
        </div>

        <div class="oil_svc_benefits">
          <div class="oil_svc_benefit is-shipper">
            <div class="oil_svc_benefit_label">平台给企业客户优惠</div>
            <div class="oil_svc_benefit_value">
              ¥{{ form.discountServiceFee || 0 }}
            </div>
            <div class="oil_svc_benefit_tip">已在托运人应付中扣减</div>
          </div>
        </div>
      </div>
      <!-- v-if="form.statusNew < 5" -->
      <div v-if="false">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="预估司机费用">
                <el-input v-model.number="estimatedDriverFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-form-item label="预估托运人费用" label-width="180px">
                <el-input v-model.number="estimatedShipperFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="损耗费用">
                <el-input v-model.number="form.wastageFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="其他费用" label-width="180px">
                <el-input v-model.number="form.abnormalFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-form-item label="到付服务费">
                <el-input v-model.number="form.taxPayFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <!-- <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="到付服务费">
              <el-input v-model.number="form.taxPayFee" :disabled="true">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col> -->

          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-form-item label="回单付服务费" label-width="180px">
                <el-input v-model.number="form.returnTaxFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-form-item label="总服务费">
                <el-input v-model.number="form.allTaxFee" :disabled="true">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </div>

      <!--  不根据状态进行判断 -->
      <el-row v-if="form.statusNew >= 5 && false">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="司机费用">
              <el-input
                v-model.number="form.deliveryFeePractical"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="托运人费用">
              <el-input
                v-model.number="form.shipmentDeliveryFeePractical"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="损耗费用">
              <el-input v-model.number="form.wastageFee" :disabled="true">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="其他费用">
              <el-input v-model.number="form.abnormalFee" :disabled="true">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="服务费">
              <el-input v-model.number="form.taxPayFee" :disabled="true">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="false">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="付款方式">
              <el-row>
                <el-col :span="6" style="margin-right: 15px">
                  <div class="radio_box">
                    <div
                      class="each_radio"
                      style="cursor: no-drop"
                      :class="{
                        sel_radio_ashes: form.payType == '1',
                        radio_un: form.payType != '1'
                      }"
                    />
                    <span :style="form.payType == '1' ? '' : ''">预付</span>

                    <el-input
                      v-model="form.prePay"
                      placeholder="请输入金额"
                      step="0.01"
                      :disabled="true"
                      style="width: calc(100% - 80px)"
                    >
                      <template slot="append"
                        >元</template
                      >
                    </el-input>
                  </div>
                  <!-- </el-radio> -->
                </el-col>
                <el-col :span="6" style="margin-right: 15px">
                  <div class="radio_box">
                    <div
                      class="each_radio"
                      style="cursor: no-drop"
                      :class="{
                        sel_radio_ashes: form.arrivePayType == '1',
                        radio_un: form.arrivePayType != '1'
                      }"
                    />
                    <span :style="form.arrivePayType == '1' ? '' : ''"
                      >到付</span
                    >
                    <el-input
                      v-model="estimatedShipperFeeArrive"
                      placeholder="请输入金额"
                      step="0.01"
                      :disabled="true"
                      style="width: calc(100% - 80px)"
                    >
                      <template slot="append"
                        >元</template
                      >
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="radio_box">
                    <div
                      class="each_radio"
                      style="cursor: no-drop"
                      :class="{
                        sel_radio_ashes: form.returnPayType == '1',
                        radio_un: form.returnPayType != '1'
                      }"
                    />
                    <span :style="form.returnPayType == '1' ? '' : ''"
                      >回单付</span
                    >
                    <el-input
                      v-model="form.returnPay"
                      placeholder="请输入金额"
                      step="0.01"
                      :disabled="true"
                      style="width: calc(100% - 80px)"
                    >
                      <template slot="append"
                        >元</template
                      >
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <!-- </el-radio-group> -->
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div
        v-if="cancelReturnPayContentList.length"
        style="margin-top:20px;"
        class="titleh1"
      >
        <code />回单付无需支付记录
      </div>
      <div>
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(activity, index) in cancelReturnPayContentList"
            :key="index"
            :timestamp="activity.gmtCreated"
          >
            <div>
              {{ activity.createdName }}({{
                activity.shipmentRemarks
                  ? "托运人"
                  : activity.driverRemarks
                  ? "司机"
                  : "平台"
              }}):
              {{
                activity.shipmentRemarks ||
                  activity.driverRemarks ||
                  activity.adminRemarks
              }}
              <div
                v-if="activity.driverRemarks"
                :class="[activity.isAgree === 1 ? 'col-blue' : 'col-red']"
              >
                {{ activity.isAgree === 1 ? "同意" : "拒绝" }}
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div v-if="showAbnormalMark" class="titleh1"><code />异常标记</div>

      <div
        v-if="showAbnormalMark"
        style="display: flex; align-items: center; gap: 20px; padding-left: 40px;"
      >
        <div v-if="form.reviewMsg">
          <span>异常原因：</span>
          <span>{{ form.reviewMsg }}</span>
        </div>
        <div
          style="color: #409EFF; cursor: pointer; flex-shrink: 0;"
          @click="openAbnormalMarkDialog"
        >
          异常标记
        </div>
      </div>

      <div class="titleh1"><code />查看协议</div>
      <div
        style="display: flex;gap:20px;color: #409EFF;padding-left:40px;cursor: pointer;"
      >
        <span @click="viewContract(1)">运输协议</span>
        <span @click="viewContract(0)">承运协议</span>
      </div>
      <div class="titleh1"><code />查看轨迹</div>
      <el-row>
        <el-col v-if="track" :span="6">
          <el-image
            style="width: 160px; height: 160px;cursor: pointer;"
            :src="imgUrl"
            @click="uploadClick"
          />
        </el-col>
        <!-- ETC信息 -->
        <el-col v-if="etcOrderTradeEntityList.length" :span="track ? 18 : 24">
          <div class="etc-records">
            <div class="etc-records__title">
              ETC通行记录（{{ etcOrderTradeEntityList.length }}）
            </div>
            <el-table
              :data="etcOrderTradeEntityList"
              border
              size="mini"
              style="width: 100%"
              max-height="320"
            >
              <el-table-column
                prop="enStationName"
                label="进站口"
                min-width="140"
                show-overflow-tooltip
                :formatter="formatEtcEmpty"
              />
              <el-table-column
                prop="enTime"
                label="进站时间"
                min-width="130"
                show-overflow-tooltip
                :formatter="formatEtcEmpty"
              />
              <el-table-column
                prop="exStationName"
                label="出站口"
                min-width="140"
                show-overflow-tooltip
                :formatter="formatEtcEmpty"
              />
              <el-table-column
                prop="exTime"
                label="出站时间"
                min-width="130"
                show-overflow-tooltip
                :formatter="formatEtcEmpty"
              />
              <el-table-column
                prop="fee"
                label="金额(元)"
                min-width="70"
                show-overflow-tooltip
                :formatter="formatEtcEmpty"
              />
            </el-table>
          </div>
        </el-col>
      </el-row>
      <div v-if="form.deleted == 1" class="titleh1"><code />取消原因</div>
      <div v-if="form.deleted == 1" style="margin-bottom:20px;">
        {{ form.platformCancelReason }}
      </div>
      <div class="titleh1"><code />操作日志</div>
      <el-row>
        <el-col :span="18">
          <div>
            <el-steps direction="vertical" :active="1">
              <el-step
                v-for="item in orderTraceList"
                :key="item.code"
                style="min-height:50px"
                :description="item.content + '    ' + item.gmtCreated"
              />
            </el-steps>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />双方评价</div>
      <el-row>
        <el-col :span="12">
          <p>司机评价托运人</p>
          <div v-for="item in commentToShipmentList" :key="item.id">
            {{ item.commentContent }}
            <div class="demo-image">
              <div
                v-for="url in item.urls"
                :key="url"
                style="display: inline-block; padding: 0 4px 4px 0;"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="item.urls"
                />
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <p>托运人评价司机</p>
          <div v-for="item in commentToDriverList" :key="item.id">
            {{ item.commentContent }}
            <div class="demo-image">
              <div
                v-for="url in item.urls"
                :key="url"
                style="display: inline-block; padding: 0 4px 4px 0;"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="item.urls"
                />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 运费申诉信息 -->
      <div
        v-if="
          orderAppealObj &&
            (orderAppealObj.appealReasonPrice ||
              orderAppealObj.priceSupportingMaterials.length)
        "
        class="titleh1"
      >
        <code />运费申诉信息
      </div>
      <div
        v-if="orderAppealObj && orderAppealObj.appealReasonPrice"
        class="orderAppealObj_text"
      >
        {{ orderAppealObj.appealReasonPrice }}
      </div>
      <div
        v-if="orderAppealObj && orderAppealObj.priceSupportingMaterials.length"
        style="display: flex;gap:20;"
      >
        <div
          v-for="item in orderAppealObj.priceSupportingMaterials"
          class="orderAppealObj_img_box"
        >
          <el-image
            style="width: 100px; height: 100px;"
            :src="item"
            :preview-src-list="orderAppealObj.priceSupportingMaterials"
          />
        </div>
      </div>
      <!-- 轨迹 -->
      <div
        v-if="
          orderAppealObj &&
            (orderAppealObj.appealReasonPath ||
              orderAppealObj.pathSupportingMaterials.length)
        "
        class="titleh1"
      >
        <code />轨迹申诉信息
      </div>
      <div
        v-if="orderAppealObj && orderAppealObj.appealReasonPath"
        class="orderAppealObj_text"
        style="margin-top:20px;"
      >
        {{ orderAppealObj.appealReasonPath }}
      </div>
      <div
        v-if="orderAppealObj && orderAppealObj.pathSupportingMaterials.length"
        style="display: flex;gap:20;"
      >
        <div
          v-for="item in orderAppealObj.pathSupportingMaterials"
          class="orderAppealObj_img_box"
        >
          <el-image
            style="width: 100px; height: 100px;"
            :src="item"
            :preview-src-list="orderAppealObj.pathSupportingMaterials"
          />
        </div>
      </div>

      <!-- 其他申诉信息 -->
      <div
        v-if="
          orderAppealObj &&
            (orderAppealObj.appealReasonOther ||
              orderAppealObj.otherSupportingMaterials.length)
        "
        class="titleh1"
      >
        <code />其他申诉信息
      </div>
      <div
        v-if="orderAppealObj && orderAppealObj.appealReasonOther"
        class="orderAppealObj_text"
      >
        {{ orderAppealObj.appealReasonOther }}
      </div>
      <div
        v-if="orderAppealObj && orderAppealObj.otherSupportingMaterials.length"
        style="display: flex;gap:20;"
      >
        <div
          v-for="item in orderAppealObj.otherSupportingMaterials"
          class="orderAppealObj_img_box"
        >
          <el-image
            style="width: 100px; height: 100px;"
            :src="item"
            :preview-src-list="orderAppealObj.otherSupportingMaterials"
          />
        </div>
      </div>

      <!-- ================= 2024-10-17 注销 开始-->
      <!-- <el-row>
        <el-col :span="6">
          <el-form-item label="运单号">
            <el-input v-model="form.orderCode" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="货物名称">
            <el-input v-model="form.coalTypeName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="货物单价">
            <el-input v-model="form.coalPrice" :disabled="true">
              <template slot="append">
                {{ form.isTrunkName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运输要求">
            <el-input v-model="form.coalName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="托运人名称">
            <el-input v-model="form.shipmentName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="托运人电话">
            <el-input v-model="form.shipmentPhone" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="司机姓名">
            <el-input v-model="form.driverName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="司机电话">
            <el-input v-model="form.driverPhone" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="承运车辆">
            <el-input v-model="form.vehicleLicense" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运单状态">
            <el-input v-model="form.status" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="成交单价">
            <el-input v-model="form.taxPrice" :disabled="true">
              <template slot="append">
                {{ form.isTrunkName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="承运单价">
            <el-input v-model="form.realPrice" :disabled="true">
              <template slot="append">
                {{ form.isTrunkName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发货联系人">
            <el-input v-model="form.shipperName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发货电话">
            <el-input v-model="form.shipperPhone" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="装货地址">
            <el-input v-model="form.shipperAddress" :disabled="true" />
          </el-form-item>
        </el-col> -->
      <!-- ================= 2024-10-17 注销 结束-->

      <!-- <el-col :span="6">
          <el-form-item label="装货详细地址">
            <el-input v-model="form.shipperDetailAddress" :disabled="true" />
          </el-form-item>
        </el-col> -->

      <!-- ================= 2024-10-17 注销 开始-->
      <!--
        <el-col :span="6">
          <el-form-item label="装货日期">
            <el-input v-model="form.fillTime" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="卸货联系人">
            <el-input v-model="form.consigneeName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货电话">
            <el-input v-model="form.consigneePhone" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="卸货地址">
            <el-input v-model="form.consigneeAddress" :disabled="true" />
          </el-form-item>
        </el-col> -->
      <!-- ================= 2024-10-17 注销 结束-->

      <!-- <el-col :span="6">
          <el-form-item label="收货详细地址">
            <el-input v-model="form.consigneeDetailAddress" :disabled="true" />
          </el-form-item>
        </el-col> -->

      <!-- ================= 2024-10-17 注销 开始-->
      <!-- <el-col :span="6">
          <el-form-item label="卸货日期">
            <el-input v-model="form.signTime" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="装货吨数">
            <el-input v-model="form.loadQuantity" :disabled="true">
              <template slot="append">
                {{ form.coalUnitName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="卸货吨数">
            <el-input v-model="form.unloadQuantity" :disabled="true">
              <template slot="append">
                {{ form.coalUnitName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="实际路耗">
            <el-input v-model="form.wastage" :disabled="true">
              <template slot="append">
                {{ form.coalUnitName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="合理路耗">
            <template v-if="form.canWastage==-1">
              不计
            </template>
            <template v-else>
              <el-input v-model="form.canWastage" :disabled="true">
                <template slot="append">{{ form.coalUnitName }}</template>
              </el-input>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结算吨位">
            <el-input v-model="form.settlementWeight" :disabled="true">
              <template slot="append">
                {{ form.coalUnitName }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="里程数">
            <el-input v-model="form.distance" :disabled="true">
              <template slot="append">
                公里
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1">
        <code />核算详情
      </div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="其他费用">
            <el-input v-model="form.extraFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button icon="el-icon-edit" @click="showEditTable=step==1" />
        </el-col>
        <el-col :span="6">
          <el-form-item label="异常费用">
            <el-input v-model="form.abnormalFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider v-if="isDriverOrAdmin" />
      <el-row v-if="isDriverOrAdmin">
        <el-col :span="6">
          <el-form-item label="司机预估运费">
            <el-input v-model="form.deliveryFeeDeserved" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="司机应收运费">
            <el-input v-model="form.deliveryFeePractical" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="司机实收运费">
            <el-input v-model="form.driverActualFreight" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="司机实收现金">
            <el-input v-model="form.driverActualCash" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="司机合计收款">
            <el-input v-model="form.deliveryCashFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="平台预付金额">
            <el-input v-model="form.platformPrepayment" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider v-if="isShipmentOrAdmin" />
      <el-row v-if="isShipmentOrAdmin">
        <el-col :span="6">
          <el-form-item label="托运人预估运费">
            <el-input v-model="form.taxFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="托运人应付金额">
            <el-input v-model="form.shipmentDeliveryFeePractical" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="托运人实付运费">
            <el-input v-model="form.shipmentActualFreight" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col> -->
      <!-- ================= 2024-10-17 注销 结束-->

      <!-- <el-col :span="6">
          <el-form-item label="托运人已付金额">
            <el-input v-model="form.allotTaxAmount" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col> -->

      <!-- ================= 2024-10-17 注销 开始-->
      <!-- <el-col :span="6">
          <el-form-item label="托运人预付金额">
            <el-input v-model="form.payTaxAmount" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="托运人实付现金">
            <el-input v-model="form.shipmentActualCash" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="托运人合计付款">
            <el-input v-model="form.shipperDeliveryFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运单保险费用">
            <el-input v-model="form.insuranceFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1">
        <code />支付费用
      </div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="托运人预付金额">
            <el-input v-model="form.payTaxAmount" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运单保险费用">
            <el-input v-model="form.insuranceFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="托运人结算支付">
            <el-input v-model="form.shipmentActualCash" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="平台预付金额">
            <el-input v-model="form.platformPrepayment" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col> -->
      <!-- ================= 2024-10-17 注销 结束-->

      <!-- <el-col :span="6">
          <el-form-item label="平台预付油点">
            <el-input v-model="form.payOil" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col> -->

      <!-- ================= 2024-10-17 注销 开始-->
      <!--
        <el-col :span="6">
          <el-form-item label="平台预付现金">
            <el-input v-model="form.payAmount" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="平台结算支付">
            <el-input v-model="form.driverActualCash" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col> -->
      <!-- ================= 2024-10-17 注销 结束-->

      <!-- <el-col :span="6">
          <el-form-item label="结算支付油点">
            <el-input v-model="form.settlementOil" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col> -->

      <!-- ================= 2024-10-17 注销 开始-->
      <!-- <el-col :span="6">
          <el-form-item label="结算支付现金">
            <el-input v-model="form.settlementCash" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="taxTargetPlatform === '2' && form.billingConfirmationStatus == 2" :span="6">
          <el-form-item label="税务开票金额">
            <el-input v-model="form.taxInvoiceAmount" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1">
        <code />回单信息
      </div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="装车位置">
            <el-input v-model="form.loadPlace" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="receiptNum-box">
          <el-form-item label="装车图片" label-width="70px">
            <div class="demo-image">
              <div v-for="url in form.fillImageInfoList" :key="url" style="display: inline-block; padding: 0 4px 4px 0;">
                <el-image
                  v-if="url&&url!=''"
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="form.fillImageInfoList"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="卸车位置">
            <el-input v-model="form.unloadPlace" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="receiptNum-box">
          <el-form-item label="卸车图片" label-width="70px">
            <div class="demo-image">
              <div v-for="url in form.signImageInfoList" :key="url" style="display: inline-block; padding: 0 4px 4px 0;">
                <el-image
                  v-if="url&&url!=''"
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="form.signImageInfoList"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- ================= 2024-10-17 注销 结束-->

      <!-- <el-row>
        <el-col :span="24" class="receiptNum-box">
          <el-form-item label="回单照片" label-width="70px">
            <div class="demo-image">
              <div v-for="url in form.receiptImageUrls" :key="url" style="display: inline-block; padding: 0 4px 4px 0;">
                <el-image
                  v-if="url"
                  style="width: 100px; height: 100px"
                  :src="url"
                  :preview-src-list="form.receiptImageUrls"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="receiptNum-box">
          <el-form-item label="回单号" label-width="70px">
            <el-input v-model="form.receiptNum" :disabled="true" placeholder="回单号" />
          </el-form-item>
        </el-col>
      </el-row> -->

      <!-- ================= 2024-10-17 注销 开始-->
    </el-form>
    <!--  <div class="titleh1">
      <code />运单轨迹
    </div>
    <el-row>
      <el-col :span="18">
        <div>
          <el-steps direction="vertical" :active="1">
            <el-step
              v-for="item in orderTraceList"
              :key="item.code"
              style="min-height:50px"
              :description="item.content +'    '+ item.gmtCreated"
            />
          </el-steps>
        </div>
      </el-col>
      <el-col v-if="track" :span="6">
        <el-image
          style="width: 160px; height: 160px;cursor: pointer;"
          :src="imgUrl"
          @click="uploadClick"
        />
      </el-col>
    </el-row>
    <div class="titleh1">
      <code />双方评价
    </div>
    <el-row>
      <el-col :span="12">
        <p>司机评价托运人</p>
        <div v-for="item in commentToShipmentList" :key="item.id">
          {{ item.commentContent }}
          <div class="demo-image">
            <div v-for="url in item.urls" :key="url" style="display: inline-block; padding: 0 4px 4px 0;">
              <el-image
                style="width: 100px; height: 100px"
                :src="url"
                :preview-src-list="item.urls"
              />
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <p>托运人评价司机</p>
        <div v-for="item in commentToDriverList" :key="item.id">
          {{ item.commentContent }}
          <div class="demo-image">
            <div v-for="url in item.urls" :key="url" style="display: inline-block; padding: 0 4px 4px 0;">
              <el-image
                style="width: 100px; height: 100px"
                :src="url"
                :preview-src-list="item.urls"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <vxe-modal v-model="showEditTable" title="其他费用" width="800" height="auto" resize>
      <el-table ref="xTable" resizable border :data="orderExtraFeeList">
        <el-table-column width="50" type="index" label="序号" />
        <el-table-column width="150" prop="extraFeeName" label="费用名称">
          <template v-slot="{ row }">
            <el-input v-model="row.extraFeeName" :disabled="true" />
          </template>
        </el-table-column>
        <el-table-column width="108" prop="extraFeeAmount" label="金额">
          <template v-slot="{ row }">
            <el-input v-model="row.extraFeeAmount" type="number" :disabled="true" />
          </template>
        </el-table-column>
        <el-table-column width="108" label="收支类型">
          <template v-slot="{row}">
            {{ row.extraPayType>0?"支出":"收入" }}
          </template>
        </el-table-column>
        <el-table-column prop="extraFeeRemark" label="备注">
          <template v-slot="{ row,}">
            <el-input v-model="row.extraFeeRemark" maxlength="255" :disabled="true" />
          </template>
        </el-table-column>
      </el-table>
    </vxe-modal> -->
    <!-- ================= 2024-10-17 注销 结束-->
    <el-dialog
      :visible.sync="showDriverInfo"
      title="司机信息"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <driver-info :code="code" />
    </el-dialog>
  </div>
</template>
<script>
import driverInfo from "./driverInfo.vue";
import { insuranceType } from "@/api/orderform";
import { OrderDetails, OrderExtraFee } from "@/api/transport";
import { getListDict } from "@/api/commonApi";
import {
  queryOrderAppealList,
  getCancelReturnPayContent,
  getContractInfo
} from "@/api/transport";
export default {
  components: {
    driverInfo
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    abnormalType: {
      type: Boolean,
      default: false
    },
    showAbnormalMark: {
      type: Boolean,
      default: false
    },
    sigleInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  // watch: {
  //   abnormalType: {
  //     handler(newVal, oldVal) {
  //       if (newVal) {
  //         this.queryOrderAppealListApi();
  //       }
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // },
  data() {
    return {
      etcOrderTradeEntityList: [],
      showDriverInfo: false,
      cancelReturnPayContentList: [],
      optionsfreightRoundingType: [
        {
          code: 0,
          name: "保留小数"
        },
        {
          code: 1,
          name: "抹除小数"
        },
        {
          code: 2,
          name: "抹除个位"
        },
        {
          code: 3,
          name: "抹除十位"
        }
      ],
      orderAppealObj: null,
      code: "",
      track: false,
      showEditTable: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      isAdmin: false,
      orderDetailStatusMap: {
        "0": "未接单",
        "1": "已接单",
        "2": "已装货",
        "3": "已卸货",
        "4": "已核算",
        "5": "部分支付",
        "6": "已打款"
      },
      form: {},
      carneme: [],
      instype: {
        type: "insureType1"
      },
      branchCode: "67a375220847460c14qingdaominlian",
      extraFeeType: [],
      extraPayType: { "0": "支出", "1": "收入" },
      preservation: {
        code: "",
        isFirst: 1
      },
      orderTraceList: [],
      commentToShipmentList: [],
      commentToDriverList: [],
      orderExtraFeeList: [],
      step: 1,
      imgUrl: require("../../assets/queueingSystem/summary_web_banner.png"),
      taxTargetPlatform: "",
      contractInfo: [],
      reverse: false
    };
  },
  computed: {
    discountPoint() {
      const shipment = this.$store.state.user.shipment || {};
      return Number(shipment.discountPoint) || 0;
    },
    oilQuotaUsageRate() {
      const oilFee = Number(this.form.oilFee) || 0;
      const payOil = Number(this.form.payOil) || 0;
      if (oilFee <= 0) return 0;
      return Math.min(100, Math.round((payOil / oilFee) * 100));
    },
    estimatedDriverFee() {
      return this.form.deliveryFeePractical || this.form.deliveryFeeDeserved;
    },
    estimatedShipperFee() {
      return this.form.shipmentDeliveryFeePractical || this.form.taxFee;
    },
    estimatedShipperFeeArrive() {
      return this.form.driverActualCash || this.form.verifyArrivePay;
    }
  },
  watch: {
    code: {
      handler(newVal) {
        if (newVal) {
          this.getContractInfoApi();
        }
      },
      immediate: true
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.taxTargetPlatform = this.$store.state.user.party.taxTargetPlatform;
  },
  methods: {
    formatEtcEmpty(row, column, cellValue) {
      return cellValue || "-";
    },
    openAbnormalMarkDialog() {
      this.$emit("openAbnormalMarkDialog", this.sigleInfo);
    },
    viewContract(type) {
      let url = this.contractInfo.find(item => item.contractType === type);
      console.log("url", url);
      window.open(url.contractPath, "_blank");
    },
    getContractInfoApi() {
      getContractInfo({ code: this.code }).then(response => {
        console.log("协议", response);
        if (response.status === 0) {
          this.contractInfo = response.data;
        }
      });
    },
    viewCertificate() {
      this.showDriverInfo = true;
    },
    getCancelReturnPayContentApi() {
      getCancelReturnPayContent({
        code: this.code
      }).then(response => {
        console.log("注销回退支付内容", response);
        if (response.status === 0) {
          this.cancelReturnPayContentList = response.data;
        }
      });
    },
    queryOrderAppealListApi(c) {
      queryOrderAppealList({
        orderCode: c
      }).then(response => {
        console.log("申诉列表", response);
        if (response.data && response.data.records.length) {
          this.orderAppealObj = response.data.records[0];
        }
      });
    },
    // 查询保险
    Insurance() {
      if (this.branchCode) {
        this.instype.branchCode = this.branchCode;
        insuranceType(this.instype).then(response => {
          this.carneme = response.data.records;
        });
      }
    },
    Getdetails(code, track) {
      this.code = code;
      this.track = true;
      this.form = {};
      OrderDetails(code).then(response => {
        this.form = Object.assign(
          {},
          response.data.order,
          response.data.orderDetail
        );
        this.etcOrderTradeEntityList = (
          response.data.etcOrderTradeEntityList || []
        )
          .slice()
          .sort((a, b) => {
            const timeA = a.exTime ? new Date(a.exTime).getTime() : 0;
            const timeB = b.exTime ? new Date(b.exTime).getTime() : 0;
            return timeA - timeB;
          });
        this.form.payType = response.data.order.payType;
        this.form.fillImageInfoList = response.data.fillImageInfoList.filter(
          item => item
        );
        this.form.signImageInfoList = response.data.signImageInfoList.filter(
          item => item
        );
        this.form.receiptImageUrls = response.data.receiptImageUrls.filter(
          item => item
        );

        this.form.abnormalImgList = response.data.abnormalImgList.filter(
          item => item
        );

        this.orderTraceList = response.data.orderTraceList;
        this.commentToShipmentList = response.data.commentToShipmentList;
        this.commentToDriverList = response.data.commentToDriverList;
        this.form.status = this.orderDetailStatusMap[this.form.status];
        if (!this.form.freightRoundingType) {
          this.form.freightRoundingType = 0;
        }
        this.Insurance();
        this.getCancelReturnPayContentApi();
      }),
        OrderExtraFee({ orderCode: this.code }).then(response => {
          this.orderExtraFeeList = response.data.records;
        });
    },
    getExtraFeeTypeDict(branchCode) {
      getListDict({ types: "extraFeeType", branchCode: branchCode }).then(
        response => {
          this.extraFeeType = response.data[0].dictList;
        }
      );
    },
    uploadClick() {
      this.$emit("openMap", this.code, this.form);
    }
  }
};
</script>

<style lang="scss" scoped>
.col-blue {
  width: 40px;
  color: #ffffff;
  background-color: #4186ef;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
}
.col-red {
  width: 40px;
  color: #ffffff;
  background-color: #f56c6c;
  width: 40px;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
}
.active_border_blue {
  border: 2px solid #4186ef;
  border-radius: 6px;
}
.active_color_blue {
  color: #4186ef;
}
.m_t_10 {
  margin-top: 10px;
}
.dottle_flex_box_item {
  width: 103px;
  text-align: right;
  padding-right: 15px;
  white-space: nowrap;
}
.dottle_flex_box {
  display: flex;
}
.border_dottle {
  border-radius: 9px;
  border: 1px dotted #d9d9d9;
  padding: 11px 5px 10px 7px;
  .driver_label {
    width: 32px;
    height: 17px;
    background: #f5f7fa;
    border-radius: 3px;
    font-weight: 400;
    font-size: 11px;
    color: #606165;
    text-align: center;
    align-items: center;
    margin-bottom: 11px;
  }
}
.orderAppealObj_img_box {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  margin-left: 10px;
  border-radius: 5px;
}
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;

  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
.etc-records {
  width: 100%;
  color: #303133;

  &__title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }
}
.el-autocomplete {
  width: 81%;
}

.el-cascader {
  width: 100%;
}

.el-select {
  width: 100%;
}
.receiptNum-box ::v-deep.el-form-item--medium .el-form-item__label {
  text-align: justify;
}

.oil_svc_panel {
  margin-top: 12px;
  padding: 14px 16px 16px;
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-sizing: border-box;
  color: #1f2329;

  .oil_svc_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .oil_svc_header_left {
    display: flex;
    align-items: center;
    min-width: 0;
    flex-wrap: wrap;
  }

  .oil_svc_pump_icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .oil_svc_title {
    font-size: 15px;
    font-weight: 600;
    color: #8b4513;
    margin-right: 8px;
  }

  .oil_svc_tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 4px;
    background: #fff1e0;
    color: #ff8a1f;
    font-size: 12px;
    line-height: 20px;
  }

  .oil_svc_detail_btn {
    flex-shrink: 0;
    height: 28px;
    padding: 0 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    color: #606266;
    font-size: 12px;
    cursor: pointer;
    outline: none;
  }

  .oil_svc_metrics {
    display: flex;
    gap: 10px;
  }

  .oil_svc_metric {
    flex: 1;
    min-width: 0;
    padding: 12px 12px 10px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    box-sizing: border-box;
  }

  .oil_svc_metric_label {
    font-size: 12px;
    color: #909399;
    line-height: 18px;
    margin-bottom: 6px;
  }

  .oil_svc_metric_code {
    color: #c0c4cc;
  }

  .oil_svc_metric_value {
    font-size: 22px;
    font-weight: 700;
    color: #303133;
    line-height: 1.2;

    &.is-orange {
      color: #ff8a1f;
    }

    &.is-red {
      color: #f5222d;
    }

    &.is-time {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.25;
    }
  }

  .oil_svc_rate {
    margin-top: 14px;
  }

  .oil_svc_rate_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
  }

  .oil_svc_rate_pct {
    font-weight: 600;
    color: #606266;
  }

  .oil_svc_progress {
    height: 8px;
    background: #eceff3;
    border-radius: 999px;
    overflow: hidden;
  }

  .oil_svc_progress_bar {
    height: 100%;
    background: #ff8a1f;
    border-radius: 999px;
  }

  .oil_svc_records {
    margin-top: 16px;
  }

  .oil_svc_records_title {
    font-size: 12px;
    color: #909399;
    line-height: 18px;
    margin-bottom: 10px;
  }

  .oil_svc_record {
    display: flex;
    align-items: center;
    padding-bottom: 14px;
    border-bottom: 1px dashed #e5e6eb;
  }

  .oil_svc_record_icon {
    width: 36px;
    height: 36px;
    margin-right: 10px;
    border-radius: 8px;
    background: #fff1f0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .oil_svc_record_info {
    flex: 1;
    min-width: 0;
  }

  .oil_svc_record_name {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 20px;
  }

  .oil_svc_record_meta {
    margin-top: 2px;
    font-size: 12px;
    color: #909399;
    line-height: 18px;
  }

  .oil_svc_record_amount {
    margin-left: 12px;
    font-size: 18px;
    font-weight: 700;
    color: #ff8a1f;
    flex-shrink: 0;
  }

  .oil_svc_benefits {
    display: flex;
    gap: 12px;
    margin-top: 14px;
  }

  .oil_svc_benefit {
    flex: 1;
    min-width: 0;
    padding: 14px 16px;
    border-radius: 8px;
    box-sizing: border-box;
    text-align: left;

    &.is-shipper {
      background: #fff7ed;
      border: 1px solid #ffd8a8;
      color: #d46b08;

      .oil_svc_benefit_value {
        color: #fa8c16;
      }
    }

    &.is-driver {
      background: #f6ffed;
      border: 1px solid #b7eb8f;
      color: #389e0d;

      .oil_svc_benefit_value {
        color: #52c41a;
      }
    }
  }

  .oil_svc_benefit_label {
    font-size: 13px;
    line-height: 20px;
  }

  .oil_svc_benefit_value {
    margin-top: 4px;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
  }

  .oil_svc_benefit_tip {
    margin-top: 4px;
    font-size: 12px;
    opacity: 0.85;
    line-height: 18px;
  }
}
</style>
<style lang="scss">
.el-picker-panel.no-atTheMoment {
  .el-button--text.el-picker-panel__link-btn {
    display: none;
  }
}

.operate_box {
  display: flex;
  justify-content: space-between;
  .frequent {
  }
  .notice {
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .operate_one {
    display: flex;
    align-items: center;
  }
  .operate_two {
  }
}
.radio_box {
  display: flex;
  align-items: center;
  .each_radio {
    width: 13px;
    height: 13px;

    border-radius: 13px 13px 13px 13px;
    cursor: pointer;
    box-sizing: border-box;
    margin-right: 12px;
  }
  .each_radio_block {
    border-radius: 0;
  }
  .radio_un {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #dcdcdc;
  }
  .sel_radio {
    background: rgba(255, 255, 255, 0.9);
    border: 4px solid #4186ef;
  }
  .sel_radio_ashes {
    background: rgba(255, 255, 255, 0.9);
    border: 5px solid #dfe4ed;
  }
  .el-input {
    margin-left: 10px;
  }
}
.positive_negative {
  display: flex;
  .positive_btn {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #d4d4d4;
    color: #ffffff;
    cursor: pointer;
  }
  .negative_btn {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4186ef;
    color: #ffffff;
  }
}

.estimated {
  flex: none;
  width: 192px;
  height: 40px;
  background: #f5fcff;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #89b8ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  box-sizing: border-box;
  .carriage {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 12px;
    color: #333333;
  }
  .money {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 22px;
    color: #4186ef;
    display: flex;
    align-items: flex-end;
    .money_unit {
      font-weight: 400;
      font-size: 16px;
      color: #4186ef;
    }
  }
}
.orderAppealObj_text {
  margin-bottom: 15px;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}
</style>
